"use strict";

import { MdErbProcessor } from "./MdErbProcessor";

module.exports = {
    Processor: MdErbProcessor
};

